import { useLang } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";

export default function ProcessSection() {
  const { t } = useLang();
  const { content } = useContent();
  const steps = content?.process_steps || [];

  return (
    <section className="section-pad bg-[var(--bg)] relative" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="overline mb-3">{t("process.overline")}</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white">
            {t("process.title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {steps.map((s, i) => (
            <div
              key={s.step}
              className="relative card-dark p-7 fade-up"
              style={{ animationDelay: `${i * 80}ms` }}
              data-testid={`process-step-${s.step}`}
            >
              <div className="font-display text-7xl font-black gold-text leading-none mb-4 opacity-90">
                {String(s.step).padStart(2, "0")}
              </div>
              <h3 className="font-display text-xl font-bold text-white mb-2">{s.title}</h3>
              <p className="text-white/60 text-sm leading-relaxed">{s.desc}</p>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-5 w-10 h-px bg-gradient-to-r from-[var(--gold)]/60 to-transparent" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
